import {
  IDiaAula,
  IPeriodoEtapa,
  ISistemaAvaliacao,
} from "@deltasge/marauders-map";
import { Typography } from "@mui/material";
import { Asterisk as RecIcon } from "mdi-material-ui";
import { format } from "date-fns";
import React, { FC } from "react";

export const Subtitle: FC<{
  dataAula?: Date;
  aula?: IDiaAula;
  isRecuperacao: boolean;
  recEtapa?: IPeriodoEtapa;
  sistemaAvaliacao?: ISistemaAvaliacao;
}> = ({ dataAula, aula, isRecuperacao, recEtapa, sistemaAvaliacao }) => {
  let subtitle = (
    <Typography variant="caption" noWrap component="p">
      Aula: {aula?.aula} - {aula?.materia?.nome}
      {dataAula ? ` - ${format(dataAula, "dd/MM/yyyy")}` : ""}
    </Typography>
  );
  if (isRecuperacao && recEtapa && sistemaAvaliacao && aula?.isRecuperacao) {
    subtitle = (
      <Typography variant="caption" noWrap component="p">
        <RecIcon
          color="secondary"
          fontSize="small"
          sx={({ spacing }) => ({
            verticalAlign: `-${spacing(0.5)}`,
            pr: spacing(0.5),
          })}
        />
        {`Aula ${aula.aula} - Recuperação de ${aula.materia?.nome} do
        ${recEtapa.etapa}º ${sistemaAvaliacao.nomeEtapa}${
          dataAula ? ` - ${format(dataAula, "dd/MM/yyyy")}` : ""
        }`}
      </Typography>
    );
  }

  return subtitle;
};
